// TODO: Move to custom ui component once confirmed with design
const sharedConentStyles =
  "border dark:text-white dark:bg-shallow dark:border-mutedaccent";

export const selectContentStyles = `${sharedConentStyles} [&>div]:px-0`;

export const dropdownContentStyles = `${sharedConentStyles} px-0`;

export const popoverContentStyles = sharedConentStyles;

export const dropdownAndSelectContentItemStyles =
  "rounded-none hover:cursor-pointer dark:hover:bg-neutral-700";
